// ** Initial State
const initialState = {
  data: [],
  total: 1,
  from: 0,
  to: 0,
  params: {},
  selectedData: null
}

const versions = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_VERSION':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params,
        from: action.from,
        to: action.to,
      }
    case 'GET_VERSION':
      return { ...state, selectedData: action.selectedData }
    case 'ADD_VERSION':
      return { ...state }
    case 'EDIT_VERSION':
      return { ...state }
    case 'DELETE_VERSION':
      return { ...state }
    default:
      return { ...state }
  }
}
export default versions
